"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const resource_1 = __importDefault(require("./Allianz/resource"));
const resource_2 = __importDefault(require("./Britannia/resource"));
const resource_3 = __importDefault(require("./Flow/resource"));
const resourcesHelper = {
    'Allianz': resource_1.default,
    'Britannia': resource_2.default,
    'Flow': resource_3.default
};
const themeResource = ((_a = process.env.REACT_APP_THEME) === null || _a === void 0 ? void 0 : _a.toString()) || "Allianz";
exports.default = resourcesHelper[themeResource];
//# sourceMappingURL=resourcesLoader.js.map